import styled, { css } from 'styled-components';
import { TextFieldSize, TextFieldState, TextFieldVariant } from '.';

type ContainerProps = {
  $size: TextFieldSize;
  $variant: TextFieldVariant;
  $state: TextFieldState;
  $error: boolean | string;
};

export const ContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${({ theme }) => theme.spacing['1']}px;
  min-height: 86px;
`;

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: row;
  align-items: center;

  ${({ theme, $size }) => {
    if ($size === 1) {
      return css`
        padding: ${theme.spacing[$size + 1]}px;
      `;
    }
    return css`
      padding-top: ${theme.spacing[$size + 1]}px;
      padding-right: ${theme.spacing[$size]}px;
      padding-bottom: ${theme.spacing[$size + 1]}px;
      padding-left: ${theme.spacing[$size]}px;
    `;
  }}

  background-color: ${({ $variant, theme }) =>
    $variant === 'surface' ? theme.tokens.colors.surface : 'none'};

  border: 2px solid
    ${({ theme, $error }) => {
      if ($error) return theme.colors.semantic.error['9'];
      return theme.colors.neutral.neutral_alpha['5'];
    }};
  gap: ${({ theme, $size }) => theme.spacing[$size]}px;

  &:hover {
    ${({ theme, $state, $error }) => {
      if ($error) return '';
      if (['disable', 'read-only'].includes($state))
        return css`
          border-color: ${theme.colors.neutral.neutral_alpha['5']};
        `;

      return css`
        border-color: ${theme.colors.accent.accent_alpha[
          $state === 'filled' ? '7' : '11'
        ]};
      `;
    }}
  }

  border-radius: ${({ theme }) => theme.radius['3']}px;
`;

export const Input = styled.input`
  display: flex;
  width: 100%;

  padding-right: ${({ theme }) => theme.spacing[1]}px;
  padding-left: ${({ theme }) => theme.spacing[1]}px;

  ${({ theme }) => {
    return css`
      font-size: ${theme.typography.font.size['3']}px;
      font-family: var(--font-${theme.typography.font.family.text});
      font-weight: ${theme.typography.font.weight.regular};
      line-height: ${theme.typography.font.line_height['3']}px;
      text-align: left;
      color: ${theme.colors.neutral.neutral_alpha['12']};

      &::placeholder {
        font-size: ${theme.typography.font.size['3']}px;
        font-family: var(--font-${theme.typography.font.family.text});
        font-weight: ${theme.typography.font.weight.medium};
        line-height: ${theme.typography.font.line_height['3']}px;
        text-align: left;
        color: ${theme.colors.neutral.neutral_alpha['9']};
      }
    `;
  }};

  &:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px transparent inset;
    box-shadow: 0 0 0px 1000px transparent inset;
    color: ${({ theme }) => theme.colors.neutral.neutral_alpha['12']};
  }
`;
